import React, { useEffect } from 'react';
import HeaderNew from '../components/NimnyLanding/HeaderNew';
import HeroSectionNew from '../components/NimnyLanding/HeroSectionNew';
import FooterNew from '../components/NimnyLanding/FooterNew';
import { NightAmbience } from '../components/NimnyLanding';
import VideoSection from '../components/NimnyLanding/VideoSection';
import PrintedEditionSection from '../components/NimnyLanding/PrintedEditionSection';
import StoriesSection from '../components/NimnyLanding/StoriesSection';
import EmailSection from '../components/NimnyLanding/EmailSection';
import { Toaster } from '../components/ui/sonner';
import { useLanguage } from '../context/LanguageContext';

const NimnyLandingNew = () => {
  const { language } = useLanguage();

  // Add WebSite structured data, BreadcrumbList, and canonical tag
  useEffect(() => {
    const langCode = language === 'ru' ? 'ru' : language === 'es' ? 'es' : 'en';
    const canonicalUrl = language === 'en' ? 'https://readnimny.com/' : `https://readnimny.com/${langCode}`;
    const homeName = language === 'ru' ? 'Главная' : language === 'es' ? 'Inicio' : 'Home';

    // WebSite Schema
    const websiteSchema = {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Nimny",
      "url": "https://readnimny.com",
      "inLanguage": langCode,
      "potentialAction": {
        "@type": "SearchAction",
        "target": "https://readnimny.com/?q={search_term_string}",
        "query-input": "required name=search_term_string"
      }
    };

    // BreadcrumbList Schema
    const breadcrumbSchema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": homeName,
          "item": "https://readnimny.com/"
        }
      ]
    };

    // Remove existing schemas
    ['website-schema', 'breadcrumb-schema'].forEach(id => {
      const el = document.getElementById(id);
      if (el) el.remove();
    });

    // Add schemas
    const websiteScript = document.createElement('script');
    websiteScript.id = 'website-schema';
    websiteScript.type = 'application/ld+json';
    websiteScript.textContent = JSON.stringify(websiteSchema);
    document.head.appendChild(websiteScript);

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.id = 'breadcrumb-schema';
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(breadcrumbScript);

    // Canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.rel = 'canonical';
      document.head.appendChild(canonical);
    }
    canonical.href = canonicalUrl;

    return () => {
      ['website-schema', 'breadcrumb-schema'].forEach(id => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, [language]);

  return (
    <div className="min-h-screen relative">
      {/* Night sky background */}
      <NightAmbience />
      
      {/* New simplified header */}
      <HeaderNew />
      
      <main className="relative">
        {/* Hero with device mockup and action buttons */}
        <HeroSectionNew />
        
        {/* Video section */}
        <VideoSection />

        {/* First print + Kindle release */}
        <PrintedEditionSection />
        
        {/* Read online */}
        <StoriesSection />
        
        {/* Email signup */}
        <EmailSection />
        
        {/* Footer */}
        <FooterNew />
      </main>
      
      <Toaster position="bottom-center" />
    </div>
  );
};

export default NimnyLandingNew;
